import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { X, Loader2 } from 'lucide-react';
import { t } from '../utils/translation';
import '../styles/components-extended.css';

export default function EventModal({ isOpen, onClose, event, onSave }) {
    const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();

    useEffect(() => {
        if (event) {
            reset({
                ...event,
                date: event.date.split('T')[0] // Format for input type=date
            });
        } else {
            reset({
                name: '',
                date: new Date().toISOString().split('T')[0],
                venue: '',
                guestCount: ''
            });
        }
    }, [event, reset, isOpen]);

    if (!isOpen) return null;

    const onSubmit = async (data) => {
        await onSave({
            ...data,
            date: new Date(data.date).toISOString(),
            guestCount: data.guestCount ? parseInt(data.guestCount, 10) : 0
        });
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3 className="modal-title">{event ? t('EVENTS_MODAL.EDIT_TITLE') : t('EVENTS_MODAL.ADD_TITLE')}</h3>
                    <button onClick={onClose} className="close-btn"><X size={20} /></button>
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="modal-body space-y-4">

                        <div className="form-group">
                            <label className="form-label">{t('EVENTS_MODAL.EVENT_NAME')}</label>
                            <input className="input" placeholder={t('EVENTS_MODAL.EVENT_NAME_PLACEHOLDER')} {...register('name', { required: 'Name is required' })} />
                            {errors.name && <p className="form-error">{errors.name.message}</p>}
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            <div className="form-group">
                                <label className="form-label">{t('EVENTS_MODAL.DATE')}</label>
                                <input type="date" className="input" {...register('date', { required: true })} />
                            </div>
                            <div className="form-group">
                                <label className="form-label">{t('EVENTS_MODAL.VENUE')}</label>
                                <input className="input" placeholder={t('EVENTS_MODAL.VENUE_PLACEHOLDER')} {...register('venue')} />
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="form-label">{t('EVENTS_MODAL.EXPECTED_GUESTS')}</label>
                            <input type="number" className="input" {...register('guestCount')} placeholder="0" />
                        </div>

                    </div>

                    <div className="modal-footer">
                        <button type="button" onClick={onClose} className="btn btn-secondary">{t('COMMON.CANCEL')}</button>
                        <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                            {isSubmitting ? <Loader2 className="animate-spin mr-2" size={16} /> : null}
                            {event ? t('EVENTS_MODAL.BTN_UPDATE') : t('EVENTS_MODAL.BTN_CREATE')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
